<section class="usa-banner" aria-label="Official government website">
	<a href="#main-content" title="Skip to main content"></a>
	<div class="usa-accordion">
		<header class="usa-banner__header">
			<div class="usa-banner__inner">
				<div class="grid-col-auto">
					<img class="usa-banner__header-flag" src="./assets/img/us_flag_small.png" alt="U.S. flag">
				</div>
				<div class="grid-col-fill tablet:grid-col-auto">
					<p class="usa-banner__header-text">An official website of the United States government</p>
					<p class="usa-banner__header-action" aria-hidden="true">Here’s how you know</p>
				</div>
				<button class="usa-accordion__button usa-banner__button" type="button" aria-expanded="false" aria-controls="gov-banner">
				<span class="usa-banner__button-text">Here’s how you know</span>
				</button>
			</div>
		</header>
		<div class="usa-banner__content usa-accordion__content" id="gov-banner" hidden>
			<div class="grid-row grid-gap-lg">
				<div class="usa-banner__guidance tablet:grid-col-6">
					<img class="usa-banner__icon usa-media-block__img" src="./assets/img/icon-dot-gov.svg" alt="Dot gov">
					<div class="usa-media-block__body">
						<p>
							<strong>The .gov means it’s official.</strong>
							<br>
							Federal government websites often end in .gov or .mil. Before sharing sensitive information, make sure you’re on a federal government site.
						</p>
					</div>
				</div>
				<div class="usa-banner__guidance tablet:grid-col-6">
					<img class="usa-banner__icon usa-media-block__img" src="./assets/img/icon-https.svg" alt="Https">
					<div class="usa-media-block__body">
						<p>
							<strong>The site is secure.</strong>
							<br>
							The <strong>https://</strong> ensures that you are connecting to the official website and that any information you provide is encrypted and transmitted securely.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="usa-banner" aria-label="DOL Banner">
	<header class="usa-banner__header bg-primary-darker">
		<div class="usa-banner__inner">
			<div class="grid-col-auto">
				<a href="https://www.dol.gov">
					<img class="usa-banner__header-flag" src="./assets/img/Agency_DOL_Logo_dark.svg" alt="Department of Labor Logo" height="20px" width="20px"/>
				</a>
			</div>
			<div class="grid-col-fill tablet:grid-col-auto" tabindex="0">
				<a href="https://www.dol.gov" tabindex="-1">
					<p class="usa-banner__header-text dol-header-font">U.S. DEPARTMENT OF LABOR</p>
				</a>
			</div>
		</div>
	</header>
</section>
<header class="usa-header usa-header--extended"><div class="usa-navbar">
	<div class="efast-logo-bar" id="extended-mega-logo">
		<div class="grid-row flex-align-center">
			<div tabindex="0" class="grid-col-auto margin-05">
				<a tabindex="-1" href="../../welcome.html"><img class="efast-logo-size" src="./assets/img/EFAST2LogoTrim2.jpg" alt="EFAST Logo"></a>
			</div>
		</div>
	</div>
	<!--<button class="usa-menu-btn">Menu</button>-->
</div>
<div id="menu-bar" style="border-bottom:solid 45px #2378c3;">
</div>
<!--<nav aria-label="Primary navigation" class="usa-nav ebsa-background">
	<div class="usa-nav__inner">
		<button class="usa-nav__close"><img src="./assets/img/close-white.svg" alt="close"></button>
		<ul class="usa-nav__primary usa-accordion">
			<li class="usa-nav__primary-item">
				<button class="usa-accordion__button usa-nav__link text-white" aria-expanded="false" aria-controls="nav-your-account">
				<span>Your Account</span>
				</button>
				
				<ul id="nav-your-account" class="usa-nav__submenu" hidden>
					<li class="usa-nav__submenu-item">
						<a href="./portal/app/login">Login</a>
					</li>
					<li class="usa-nav__submenu-item">
						<a href="./portal/app/userCreate">Register</a>
					</li>
					<li class="usa-nav__submenu-item">
						<a target="_blank" href="https://www.dol.gov/agencies/ebsa/about-ebsa/our-activities/resource-center/faqs/efast2-credentials">Login & PIN Help</a>
					</li>
				</ul>
			</li>
			<li class="usa-nav__primary-item efast-menu-mobile-hov">
				<a class="usa-nav__link" href="./portal/app/disseminatePublic"><span>Filing Search</span></a>
			</li>
			<li class="usa-nav__primary-item">
				<button class="usa-accordion__button usa-nav__link" aria-expanded="false" aria-controls="nav-help">
				<span>Help</span>
				</button>
				<ul id="nav-help" class="usa-nav__submenu" hidden>
					<li class="usa-nav__submenu-item">
						<a href="./fip/pubs/help_5500_5500SF.html">With the Form 5500 and 5500-SF</a>
					</li>
					<li class="usa-nav__submenu-item">
						<a href="./fip/pubs/help_5500EZ.html">With the Form 5500-EZ</a>
					</li>	
					<li class="usa-nav__submenu-item">
						<a href="./fip/pubs/help_PPP.html">For a Pooled Plan Provider</a>
					</li>
					<li class="usa-nav__submenu-item">
						<a href="./ContactUs/Contact.html">Contact Us</a>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</nav>
-->
</header>